export default "__VITE_ASSET__5uJTK1kj__"